<agm-map [latitude]="52.360216" [longitude]="4.895168" [zoom]="12">
  <div *ngFor="let lat of latList;let i=index">
    <agm-marker [latitude]="lat" [longitude]="lngList[i]"></agm-marker>
  </div>
</agm-map>
